export let solicitudesRedux=(valor)=>{ return {type:"SOLICITUDES",payload:valor} };
export let solicitudesEstado=(valor)=>{ return {type:"SOLICITUDES_ESTADO",payload:valor} };